import script from "./ColumnBox.vue?vue&type=script&setup=true&lang=js"
export * from "./ColumnBox.vue?vue&type=script&setup=true&lang=js"

import "./ColumnBox.vue?vue&type=style&index=0&id=263eaf2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-263eaf2c"]])

export default __exports__